<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">
                <dateselectionheader v-if="!indicatorDateView"
                        :label="dateSelectionStart.format('MMMM') + ' ' + dateSelectionStart.format('YYYY')"
                        @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
                        @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
                        @CalendarOpen="OpenDateSelection"
                        @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>
                
                <div class="header date month" v-if="indicatorDateView">
                    <div class="fas fa-angle-left" v-on:click="indicatorDateView = null"></div>
                    <div class="label bold">{{indicatorDateView.format('dd').toUpperCase() + ', '}}</div>
                    <div class="label">{{indicatorDateView.format('DD') + '.' + indicatorDateView.format('MM') + '.'}}</div>
                    <div class="label">{{indicatorDateView.format('YYYY')}}</div>
                    <div class="fas fa-calendar" v-on:click="OpenDateSelection($event)"></div>
                </div>
            </div>

            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
            <!--<div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <datatablepaging :pageLength="20" :maxItems="DataTableFilteredItems().length" @update="(options) => { pageOptions = options }" />
            <datatabletextfilter @update="SetFilterText"></datatabletextfilter>
            <datatablefilter :filterOptionsState="dataTableFilterOptions" @update="(filtersSelected) => { filters = filtersSelected }" />  -->
        </div>
        
        <div class ="scrollbar-container">
            <!--<div class="page-settings content" style="margin-top: 12px;">
                <div class="full">
                    <div class="mainheader">
                        <div class="half">
                            Prognosen
                        </div>
                    </div>
                </div>
                <div class="full" style="text-aling: left;">
                    <div class="full label" style="text-align: left;">
                        Die Prognosen werden von MyStore (Manager), MD und DataInsight bereitgestellt und mit den tatsächlichen Umsätzen verglichen. Der Wert mit der gerinsten Abweichung im Vergleich zum tatsächlichen Umsatz wird jeweils grün hervorgehoben. Der RMSE (Root-Mean-Square Error) misst, wie weit im Schnitt die prognostizierten Werte von den tatsächlichen Werten abweichen, indem man die Fehler quadriert, den Durchschnitt nimmt und dann die Quadratwurzel zieht. Umso niedriger der RMSE ist, umso genauer ist die Vorhersage.
                    </div>
                </div>
            </div> -->
            <div style="max-width: 1500px; margin: 24px;">
                <div class="alert alert-info m-5" role="alert" v-if="forecastLoading">
                    <p class="m-0">
                        <i class="fas fa-spinner fa-spin"></i><br/>
                        {{ $t('roster.comp.pleaseWait') }}! MD Prognose wird geladen.
                    </p>
                </div>
                <div class="alert alert-error m-5" role="alert" v-if="forecastLoadingError">
                    <p class="m-0">MD Prognose konnte nicht geladen werden.</p>
                </div>
               


                <div style=" width:100%; margin:0 0; padding: 0px;">
                    <!-- <div style="width: 70%; box-sizing: border-box; margin-left: 15%"> -->
                        <div>
                            
                            <table class="table mt-5">
                                <thead>
                                    <tr>
                                        <th scope="col" style="text-align: left;"><small><em class="text-muted">({{comparisons}} Datenpunkte)</em></small></th>
                                        <th scope="col">Manager</th>
                                        <th scope="col">MD</th>
                                        
                                        <!-- <th scope="col">DataInsight</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr @click="moreInfoExpanded = !moreInfoExpanded">
                                        <td scope="col" style="text-align: left;"><strong>Accuracy (WMAPE)</strong></td>
                                        <td :class="{ info: accuracy['winner'] == 'manager' }"><strong v-if="!isNaN(accuracy['manager']) && accuracy['manager'] != 0">{{accuracy['manager'].toLocaleString() }}</strong></td>
                                        <td :class="{ info: accuracy['winner'] == 'forecast' }"><strong v-if="!isNaN(accuracy['forecast']) && accuracy['forecast'] != 0">{{ accuracy['forecast'].toLocaleString() }}</strong></td>
                                        <!--<td :class="{ info: accuracy['winner'] == 'datainsight' }"><strong v-if="!isNaN(accuracy['datainsight']) && accuracy['datainsight'] != 0">{{ accuracy['datainsight'].toLocaleString() }}</strong></td>
                                        -->
                                    </tr>
                                    
                                    <tr v-if="moreInfoExpanded">
                                        <td scope="col" style="text-align: left;">Wurzel des mittleren quadratischen Fehlers (RMSE)</td>
                                        <td :class="{ info: rmsds['winner'] == 'manager' }"><strong v-if="!isNaN(rmsds['manager']) && rmsds['manager'] != 0">{{ rmsds['manager'].toLocaleString() }}</strong></td>
                                        <td :class="{ info: rmsds['winner'] == 'forecast' }"><strong v-if="!isNaN(rmsds['forecast']) && rmsds['forecast'] != 0">{{ rmsds['forecast'].toLocaleString() }}</strong></td>
                                        <!--<td :class="{ info: rmsds['winner'] == 'datainsight' }"><strong v-if="!isNaN(rmsds['datainsight']) && rmsds['datainsight'] != 0">{{ rmsds['datainsight'].toLocaleString() }}</strong></td>
                                        -->
                                    </tr>
                                    
                                    
                                    <tr v-if="moreInfoExpanded">
                                        <td scope="col" style="text-align: left;">Abs. Abweichung in Tsd. €</td>
                                        <td :class="{ info: deviationsAbsEuro['winner'] == 'manager' }"><span v-if="!isNaN(deviationsAbsEuro['manager']) && deviationsAbsEuro['manager'] != 0">{{ Math.round((deviationsAbsEuro['manager']/1000)).toLocaleString() }} Tsd. €</span></td>
                                        <td :class="{ info: deviationsAbsEuro['winner'] == 'forecast' }"><span v-if="!isNaN(deviationsAbsEuro['forecast']) && deviationsAbsEuro['forecast'] != 0">{{ Math.round((deviationsAbsEuro['forecast']/1000)).toLocaleString() }} Tsd. €</span></td>
                                        <!--<td :class="{ info: deviationsAbsEuro['winner'] == 'datainsight' }"><span v-if="!isNaN(deviationsAbsEuro['datainsight']) && deviationsAbsEuro['datainsight'] != 0">{{ Math.round((deviationsAbsEuro['datainsight']/1000)).toLocaleString() }} Tsd. €</span></td>
                                        -->
                                    </tr>
                                    <tr v-if="moreInfoExpanded">
                                        <td scope="col" style="text-align: left;">Anz. besser als Manager</td>
                                        <td></td>
                                        <td :class="{ info: sumBest['winner'] == sumBest['forecast'] }">{{ sumBest['forecast'] }}</td>
                                        <!--<td :class="{ info: sumBest['winner'] == sumBest['datainsight'] }">{{ sumBest['datainsight'] }}</td>-->
                                    </tr>


                                    <tr v-if="moreInfoExpanded" class="text-muted">
                                        <td scope="col" style="text-align: left;">Gesamt Umsatz ( IST: <strong>{{ Math.round((sumIST/1000)).toLocaleString() }} Tsd. €</strong> )</td>
                                        
                                        <td>{{ (Math.round(sumPLAN['manager']/1000)).toLocaleString() }} Tsd. €</td>
                                        <td>{{ (Math.round(sumPLAN['forecast']/1000)).toLocaleString() }} Tsd. €</td>
                                       
                                        <!--<td>-</td>-->
                                    </tr>

                                    <!--<tr v-if="moreInfoExpanded" class="text-muted">
                                        <td scope="col" style="text-align: left;">Gesamt Netto-Umsatz ( IST: <strong>{{ Math.round((sumNetIST/1000)).toLocaleString() }} Tsd. €</strong> )</td>
                                        
                                        <td>-</td>
                                        <td>-</td>
                                        
                                        <td>{{ (Math.round(sumPLAN['datainsight']/1000)).toLocaleString() }} Tsd. €</td>
                                    </tr> -->
                                    <tr v-if="moreInfoExpanded" class="text-muted">
                                        <td scope="col" style="text-align: left;">Totale Abweichung</td>
                                        <td :class="{ info: sumTotalDev['winner'] == 'manager' }">{{ (Math.round(sumTotalDev['manager'])).toLocaleString() }} €</td>
                                        <td :class="{ info: sumTotalDev['winner'] == 'forecast' }">{{ (Math.round(sumTotalDev['forecast'])).toLocaleString() }} €</td>
                                        <!-- <td :class="{ info: sumTotalDev['winner'] == 'datainsight' }">{{ (Math.round(sumTotalDev['datainsight'])).toLocaleString() }} €</td> -->
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    <!-- </div> -->
                </div>

                <div style="margin-top: 32px; text-align: left; font-family: DistrictProBook; font-size: 16px; font-weight: bold; color: #6d8d23;">
                    Detaillierte Werte
                </div>
                <div class="full split-flat"></div>

                <table class="table table-condensed mt-3 mb-3">
                    <thead>
                        <tr>
                            <th scope="col" class="border-right border-left" style="text-align: left;"><strong>Tag</strong></th>
                            <th scope="col" class="border-right border-left" style="text-align: left;"><strong>Datum</strong></th>
                            <th scope="col" class="border-right" style="text-align: right;"><strong>IST Umsatz</strong></th>
                            <th scope="col" style="text-align: right;">Manager Planung</th>
                            <th scope="col" class="border-right" style="text-align: right;">Manager R(M)SE</th>
                            <th scope="col" class="border-right" style="text-align: right;">Manager Acc.</th>
                            <th scope="col" style="text-align: right;">MD Prognose</th>
                            <th scope="col" class="border-right" style="text-align: right;">MD R(M)SE</th>
                            <th scope="col" class="border-right" style="text-align: right;">MD Acc.</th>
                           <!--
                            <th scope="col" class="border-right" style="text-align: right;"><strong>IST Netto Umsatz</strong></th>
                            <th scope="col" style="text-align: right;">DataInsight Prognose</th>
                            <th scope="col" class="border-right" style="text-align: right;">DataInsight R(M)SE</th>
                            <th scope="col" class="border-right" style="text-align: right;">DataInsight Acc.</th> -->
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(value, key, index) in dailyTable" v-if="value.expanded" @click="toggle(value,key,index)" :class="{ 'mouse-pointer': !value.hourly }">
                            <!-- Tag -->
                            <td class="border-right border-left" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: left;">
                                <strong v-if="!value.hourly && value.day">{{ value.day }}</strong>
                            </td>
                            <!-- Datum -->
                            <td class="border-right border-left" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: left;">
                                <small v-if="value.hourly && value.date">{{ value.date }}</small>
                                <p v-if="!value.hourly && value.date">{{ value.date }}</p>
                            </td>
                            
                            <!-- IST UMSATZ -->
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.actualSalesRounded != null">
                                    <div v-if="value.hourly">
                                        <small>{{ value.actualSalesRounded.toLocaleString() }} €</small>
                                    </div>
                                    <div v-else>
                                        <p :class="{'info-nobg': value.isPast}">{{ value.actualSalesRounded.toLocaleString() }} €</p>
                                    </div>
                                </div>
                                <div v-else></div>
                            </td>

                            <!-- MGR PLANUNG -->
                            <td :class="{nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'manager',infoHourly: value.hourly && value.winner === 'manager', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.plannedSalesRounded != null">
                                    <div v-if="value.hourly">
                                        <i v-if="value.plannedSales > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.plannedSales < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        <small>{{ value.plannedSalesRounded.toLocaleString() }} €</small>
                                    </div>
                                    <div v-else>
                                        <i v-if="value.plannedSales > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.plannedSales < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        {{ value.plannedSalesRounded.toLocaleString() }} €
                                    </div>
                                </div>
                                <div v-else></div>

                                
                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'manager',infoHourly: value.hourly && value.winner === 'manager', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.plannedDiffRMSE != null && value.actualSalesRounded != null && !isNaN(value.plannedDiffRMSE)">
                                    <small v-if="value.hourly">{{ value.plannedDiffRMSE.toLocaleString() }}</small>
                                    <p v-if="!value.hourly">{{ value.plannedDiffRMSE.toLocaleString() }}</p>
                            
                                </div>
                                <small v-else></small>
                                
                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'manager',infoHourly: value.hourly && value.winner === 'manager', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="!value.hourly">
                                    {{value.accuracyManager}}%
                                </div>
                                <div v-else>
                                    <small></small>
                                </div>
                            </td>

                            <!-- MD PLANUNG -->
                            <td :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'forecast',infoHourly: value.hourly && value.winner === 'forecast', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.forecastRounded != null">
                                    <div v-if="value.hourly">
                                        <i v-if="value.forecast > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.forecast < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        <small>{{ value.forecastRounded.toLocaleString() }} €</small>
                                    </div>
                                    <div v-else>
                                        <i v-if="value.forecast > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.forecast < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        {{ value.forecastRounded.toLocaleString() }} €
                                    </div>
                                </div>
                                <div v-else></div>

                                
                              
                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'forecast',infoHourly: value.hourly && value.winner === 'forecast', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.forecastDiffRMSE != null && value.actualSalesRounded != null && !isNaN(value.forecastDiffRMSE)">
                                    <small v-if="value.hourly">{{ value.forecastDiffRMSE.toLocaleString() }}</small>
                                    <p v-if="!value.hourly">{{ value.forecastDiffRMSE.toLocaleString() }}</p>
                            
                                </div>
                                <small v-else></small>

                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'forecast',infoHourly: value.hourly && value.winner === 'forecast', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="!value.hourly">
                                    {{value.accuracyForecast}}%
                                </div>
                                <div v-else>
                                    <small></small>
                                </div>
                            </td>

                            

                            <!-- NETTO IST UMSATZ -->
                            <!--
                            <td class="border-right" :class="{nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na',  'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.actualNetSalesRounded != null">
                                    <div v-if="value.hourly">
                                        <small>{{ value.actualNetSalesRounded.toLocaleString() }} €</small>
                                    </div>
                                    <div v-else>
                                        <p :class="{'info-nobg': value.isPast}">{{ value.actualNetSalesRounded.toLocaleString() }} €</p>
                                    </div>
                                </div>
                                <div v-else></div>
                            </td> -->

                             <!-- DataInsight PLANUNG 
                            <td :class="{nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'datainsight',infoHourly: value.hourly && value.winner === 'datainsight', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.dataInsightSalesRounded != null">
                                    <div v-if="value.hourly">
                                        <i v-if="value.dataInsightSales > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.dataInsightSales < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        <small>{{ value.dataInsightSalesRounded.toLocaleString() }} €</small>
                                    </div>
                                    <div v-else>
                                        <i v-if="value.dataInsightSales > value.actualSales" class="fas fa-arrow-up text-primary fa-xs"></i>
                                        <i v-if="value.dataInsightSales < value.actualSales" class="fas fa-arrow-down text-danger fa-xs"></i>
                                        {{ value.dataInsightSalesRounded.toLocaleString() }} €
                                    </div>
                                </div>
                                <div v-else></div>

                                
                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'datainsight',infoHourly: value.hourly && value.winner === 'datainsight', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="value.dataInsightSalesDiffRMSE != null && value.actualSalesRounded != null && !isNaN(value.dataInsightSalesDiffRMSE)">
                                    <small v-if="value.hourly">{{ value.dataInsightSalesDiffRMSE.toLocaleString() }}</small>
                                    <p v-if="!value.hourly">{{ value.dataInsightSalesDiffRMSE.toLocaleString() }}</p>
                            
                                </div>
                                <small v-else></small>
                                
                            </td>
                            <td class="border-right" :class="{ nowinner: !value.hourly && value.winner === 'na', nowinnerHourly: value.hourly && value.winner === 'na', info: !value.hourly && value.winner === 'datainsight',infoHourly: value.hourly && value.winner === 'datainsight', 'minimal-padding': value.hourly, 'mouse-pointer': !value.hourly }" style="text-align: right;">
                                <div v-if="!value.hourly">
                                    {{value.accuracyDataInsight}}%
                                </div>
                                <div v-else>
                                    <small></small>
                                </div>
                            </td>
                            -->
                        </tr>
                        <!-- More rows as per your data -->
                    </tbody>
                </table>
            </div>

        </div>

        <!--<datatable :state="dataTableState" :pageState="pageOptions" :filterState="filters" :filterCheckState="dataTableFilterOptions" :rowSelect="true" @rows-selected="UpdateRows"/> -->

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <!--<div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>-->
        </div>
    </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
import moment from "moment-timezone";
import { th } from 'date-fns/locale';
import { format } from 'date-fns';
export default {
  name: 'forecastoverview',
    components: {
        datatable,
    },
  data () {
    return {
        moreInfoExpanded: false,


        forecastLoaded: false,
        forecastLoading: false,
        forecastLoadingError: false,


        salesIndicatorId: "",
        netSalesIndicatorId: "",


        planningGroupMap: {},
        crewlaborEntryMonthMap: {},
        dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
        viewState: 1,
        loading: false,
        currentGroup: null,
        editFlag: false,

        planningIndicatorTypeMap: {},
        recommendation: {},
 
        currentPlanningIndicatorRow: undefined,
        planningIndicator: {
            id: null,
            amount: 0,
            typeId: null,
            planned: true,
            fromDate: null,
            fromTime: null,
            toDate: null,
            toTime: null,
            description: "", 
        },

        selectedRow: null,
        recommendationRows: [],
        planningIndicatorerror: false,
        showPlanned: true,
        recommendPlanned: true,
        indicatorDateView: null,
        indicatorDateMonth: this.$helpers.getCurrentMonthMomentTZ().date(1),
        loadingText: this.$t('indicator.main.loadKeyFigures'),
        indicatorsByDayMap: {},


        salesData: [],
        netSalesData: [],
        
        salesMapActual: {},
        salesMapActualDaily: {},

        netSalesMapActual: {},
        netSalesMapActualDaily: {},
        
        salesMapPlanned: {},
        salesMapPlannedDaily: {},
        
        managerMapDailySquared: {},
        managerMapDailyLength: {},

        forecastMap: {},
        forecastMapDailySquared: {},
        forecastMapDailyLength: {},
        forecastMapDaily: {},
        forecastData: [],
        forecastDataHistoric: [],
        
  

        dataInsightData: [],
        dataInsightMapDaily: {},
        dataInsightMap: {},
        dataInsightMapDailySquared: {},
        dataInsightMapDailyLength: {},

        rmsds: {'manager':0,'forecast':0, datainsight: 0, 'winner':0},
        rmsdLengths: {'manager':0,'forecast':0, datainsight: 0},
        rmsdSquareSums: {'manager':0,'forecast':0, datainsight: 0},

        accuracy: {manager: 0, forecast: 0, datainsight: 0, winner: 0},
        wmape: {manager: 0, forecast: 0, datainsight: 0},

        deviationsAbsEuro: {'manager':0,'forecast':0, datainsight: 0,'winner':0},

        comparisons: 0,
        

        sumBest: {'manager':0,'forecast':0, datainsight: 0,'winner':0},

        sumIST: 0,
        sumNetIST: 0,
        sumPLAN: {'manager':0,'forecast':0, datainsight: 0,'winner':0},
        sumTotalDev: {'manager':0,'forecast':0, datainsight: 0,'winner':0},

        expandedMap: {},
        dailyTable: [],

        rebuild: 0,
    }
  },
  
  created: function () {
    if(this.rosterFromTo != null){
        let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
        this.setDateSelection(startDate, true);
    } else {
        this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ(), true);
    }
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        console.log("CREATED REFRESH");
        this.refresh();
    }
  },
  computed: {
        ...mapGetters(['storeId', 'rosterFromTo', 'crewlaborPlanningMap', 'planningEmployeeMap', 'spotMap', 'storeSettings']),
        headerButtons(){

                let view = this;

                let state= {
                    buttons: []
                };
                state.buttons.push({
                    type: "block",
                    icon: "fa-sync-alt",
                    click: () => {
                        view.refresh(true);
                    },
                    tooltip: this.$t('global.general.refreshData'),
                    helperText: this.$t('indicator.crew.reloadDataGui')
                });

                if(!this.forecastLoaded){
                    state.buttons.push({type: "block green", icon: "fa-cloud-download",click: ($event) => {this.loadForecastData()},tooltip: 'MD Prognose laden', title: 'MD Prognose laden'});
                }
               
                /*state.buttons.push({type: "block red", icon: "fa-cloud-download",click: ($event) => {this.loadDataInsightForecastData()},tooltip: 'DataInsight Prognose laden', title: 'DataInsight Prognose laden laden'});
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-file-download",
                    click: () => {
                        view.exportDataInsightToCSV();
                    },
                    tooltip: 'DataInsight Forecast als CSV-Datei exportieren',
                    helperText: "Forecast als CSV-Datei exportieren",
                    
                
                }) */
                
                state.buttons.push({
                    type: "block border",
                    icon: "fa-file-download",
                    click: () => {
                        view.exportManagerToCSV();
                    },
                    tooltip: 'Management Forecast als CSV-Datei exportieren',
                    helperText: "Management Forecast als CSV-Datei exportieren",
                    
                
                })
                if(this.forecastLoaded){
                    
                    state.buttons.push({
                        type: "block green border",
                        icon: "fa-file-download",
                        click: () => {
                            view.exportMDForecastToCSV();
                        },
                        tooltip: 'MD Forecast als CSV-Datei exportieren',
                        helperText: "MD Forecast als CSV-Datei exportieren",
                        
                    
                    })
                }

                


                state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                ];
                
                return state;
    },
    
    
  },
  watch: { 
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh();
    },   
    rosterFromTo() {
        console.log("FROM TO CHANGED");
        if(this.$store.state.loggedIn){
            this.refresh();
        } 
    }, 
  },
  // methods that implement data logic.
    methods: {
        setDateSelection(date, calculateRosterFromTo){
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;
            if(this.indicatorDateView) {
                this.indicatorDateView = date.clone();
            } else {
                this.indicatorDateMonth = date.clone().startOf('month');
            }
            if(calculateRosterFromTo){
                //update vuex store with calculated from to => triggers reload of data via refresh
                let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
            } else {
                //dont update vuex from to, only update client side view
            }
        },
        toggle: function(value,key,index){
            if(!value.hourly){
                for(let i = 0;i <= 23; i++){
                    let dateKey = value.mapsKey + " " + i.toString().padStart(2, '0');
                    this.expandedMap[dateKey] = !this.expandedMap[dateKey];
                }
            }
            this.calculateDailyMap();
            this.rebuild++;
        },
        refresh: function(){
            let view = this;
            if(!this.loading){
                this.loading = true;
                view.createExpandedMap();
                this.salesMapPlannedDaily = {};
                this.salesMapActualDaily = {};
                this.netSalesMapActualDaily = {};
                this.salesMapPlanned = {};
                this.salesMapActual = {};
                this.netSalesMapActual = {};
                this.managerMapDailySquared = {};
                this.managerMapDailyLength = {};

                this.forecastMapDaily = {};
                this.forecastMapDailySquared = {};
                this.forecastMapDailyLength = {};
                this.forecastMap = {};
                

                this.dataInsightMapDaily = {};
                this.dataInsightMapDailySquared = {};
                this.dataInsightMapDailyLength = {};
                this.dataInsightMap = {};

                this.rmsds = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
                this.rmsdLengths = {'manager':0,'forecast':0, datainsight: 0};
                this.rmsdSquareSums = {'manager':0,'forecast':0, datainsight: 0};

                this.accuracy = {manager: 0, forecast: 0, datainsight: 0, winner: 0};
                this.wmape = {manager: 0, forecast: 0, datainsight: 0};

                this.deviationsAbsEuro = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
                this.comparisons = 0;
               
                this.sumBest = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
                this.sumIST = 0;
                this.sumNetIST = 0;
                this.sumPLAN = {'manager':0,'forecast':0, datainsight: 0};
                this.sumTotalDev = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
                this.salesData = [];
                this.netSalesData = [];
                
               

                view.forecastLoading = false;
                view.forecastLoaded = false;
                view.forecastLoadingError = false;

                let start = this.dateSelectionStart.clone().startOf('month');

                let from = this.dateSelectionStart.clone().startOf('month').format();
                let to = start.clone().add(1,'months').format();

                this.$helpers.GetCall('/api/sec/planningindicatortype').then(response => {
                    view.updatePlanningIndicatorTypes(response.data);
                    return view.loadPlanningIndicatorsPagedCompletely(from, to, this.salesIndicatorId);
                }).then(res => {
                    this.salesData = res;
                    this.createSalesMap();
                    return view.loadPlanningIndicatorsPagedCompletely(from, to, this.netSalesIndicatorId);
                    
                }).then(res => {
                    this.netSalesData = res;
                    this.createNetSalesMap();
                   
                    this.calculateDailyMap();
                    view.loading = false;
                    
                }).catch(function (error) {
                    view.loading = false;
                    console.log(error)
                });
            }
            
        },
        calculateDailyMap(){
           
            if(this.rebuild < 0){
                console.log("ASDF");
            }
            let myTable = [];

            this.rmsds = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
            this.rmsdLengths = {'manager':0,'forecast':0, datainsight: 0};
            this.rmsdSquareSums = {'manager':0,'forecast':0, datainsight: 0};

            this.accuracy = {manager: 0, forecast: 0, datainsight: 0, winner: 0};
            this.wmape = {manager: 0, forecast: 0, datainsight: 0};
            
            this.deviationsAbsEuro = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
           
            this.comparisons = 0;
            
            
            this.sumBest = {'manager':0,'forecast':0, datainsight: 0,'winner':0};
            this.sumIST = 0;
            this.sumNetIST = 0;
            this.sumPLAN = {'manager':0,'forecast':0, datainsight: 0};
            this.sumTotalDev = {'manager':0,'forecast':0, datainsight: 0,'winner':0};

            let dayStats = {};
            let todayStart = this.$helpers.getMomentTZ().startOf('day');
            let start = this.dateSelectionStart.clone().startOf('month');
            let end = start.clone().add(1,'months');
            while(end.diff(start) > 0){
                let dayTime = start.clone();
                let dateKeyDaily = dayTime.format("YYYY-MM-DD");
                let dateKey = dayTime.format("YYYY-MM-DD HH");
                let visibleDate = dayTime.clone().locale('de').format("DD.MM.YYYY");
                let visibleDay = dayTime.clone().locale('de').format("dd").toUpperCase();
                let visibleHourFrom = dayTime.clone().locale('de').format("HH:00");
                let visibleHourTo = dayTime.clone().add(1,'hours').locale('de').format("HH:00");

                if(dayStats[dateKeyDaily] == undefined){
                    dayStats[dateKeyDaily] = { sumManagerWeights: 0, sumForecastWeights: 0, sumDataInsightWeights: 0, 
                                               sumManagerSales:0, sumForecastSales:0, sumDataInsightSales:0};
                }

                /* ============================================================================= */
                // Block für den Summierten Tag
                /* ============================================================================= */
                if(dayTime.format("HH") == "00"){
                    let dDiff = dayTime.diff(todayStart);
                    console.log("DDIFF: "+dDiff);
                    let row = {  expanded: this.expandedMap[dateKeyDaily],  
                                hourly: false, 
                                date: visibleDate, 
                                day: visibleDay, 
                                forecast: this.forecastMapDaily[dateKeyDaily], 
                                plannedSales: this.salesMapPlannedDaily[dateKeyDaily], 
                                actualSales: this.salesMapActualDaily[dateKeyDaily],
                                actualNetSales: this.netSalesMapActualDaily[dateKeyDaily], 
                                isPast: dayTime.diff(todayStart) < 0,
                                dataInsightSales: this.dataInsightMapDaily[dateKeyDaily], 
                                mapsKey: dateKeyDaily };

                    if(row.actualSales != null){ row.actualSalesRounded = Math.round(row.actualSales); }
                    if(row.actualNetSales != null){ row.actualNetSalesRounded = Math.round(row.actualNetSales); }
                    if(row.plannedSales != null){ row.plannedSalesRounded = Math.round(row.plannedSales); }

                    if(row.forecast != null){ row.forecastRounded = Math.round(row.forecast); }
                   
                    if(row.dataInsightSales != null){ row.dataInsightSalesRounded = Math.round(row.dataInsightSales); }

                    if(row.plannedSales != null && row.actualSales != null){
                        row.plannedDiff = Math.abs(row.actualSales - row.plannedSales); 
                        row.plannedDiffPercent = Math.abs((row.plannedDiff/row.actualSales*100)); 
                    }
                    if(row.forecast != null && row.actualSales != null){ 
                        row.forecastDiff = Math.abs(row.actualSales - row.forecast);
                        row.forecastDiffPercent = Math.abs((row.forecastDiff/row.actualSales*100)); 
                    }
                    
                    if(row.dataInsightSales != null && row.actualNetSales != null){ 
                        row.dataInsightSalesDiff = Math.abs(row.actualNetSales - row.dataInsightSales);
                        row.dataInsightSalesDiffPercent = Math.abs((row.dataInsightSalesDiff/row.actualNetSales*100)); 
                    }
                    
                    row.plannedDiffRMSE = Math.round(Math.sqrt(this.managerMapDailySquared[dateKeyDaily] / this.managerMapDailyLength[dateKeyDaily]));
                    row.forecastDiffRMSE = Math.round(Math.sqrt(this.forecastMapDailySquared[dateKeyDaily] / this.forecastMapDailyLength[dateKeyDaily]));
                    
                    row.dataInsightSalesDiffRMSE = Math.round(Math.sqrt(this.dataInsightMapDailySquared[dateKeyDaily] / this.dataInsightMapDailyLength[dateKeyDaily]));

                    

                    myTable.push(row);
                }
                
                /* ============================================================================= */
                // Block für die einzelnen Stunden
                /* ============================================================================= */
                let row = {
                    expanded: this.expandedMap[dateKey],
                    hourly: true,
                    date: visibleHourFrom + " - " + visibleHourTo,
                    forecast: this.forecastMap[dateKey],
                    plannedSales: this.salesMapPlanned[dateKey],
                    actualSales: this.salesMapActual[dateKey],
                    actualNetSales: this.netSalesMapActual[dateKey],
                    dataInsightSales: this.dataInsightMap[dateKey],
                    winner: 'na',
                    day: '',
                    mapsKey: dateKey
                };
                
                if(row.actualSales != null){ 
                    row.actualSalesRounded = Math.round(row.actualSales);
                    this.sumIST += row.actualSales;
                    if(row.plannedSales != null){ 
                        this.sumPLAN['manager'] += row.plannedSales;
                    }
                    if(row.forecast != null){ 
                        this.sumPLAN['forecast'] += row.forecast;
                    }
                   
                    
                }
                if(row.actualNetSales != null){
                    row.actualNetSalesRounded = Math.round(row.actualNetSales);
                    this.sumNetIST += row.actualNetSales;
                    if(row.dataInsightSales != null){ 
                        this.sumPLAN['datainsight'] += row.dataInsightSales;
                    }
                }
                if(row.plannedSales != null){ 
                    row.plannedSalesRounded = Math.round(row.plannedSales);
                }
                if(row.forecast != null){ 
                    row.forecastRounded = Math.round(row.forecast); 
                }

                if(row.dataInsightSales != null){ 
                    row.dataInsightSalesRounded = Math.round(row.dataInsightSales); 
                }


                if(row.plannedSales != null && row.actualSales != null){
                    row.plannedDiff = Math.abs(row.actualSales - row.plannedSales);
                    row.plannedDiffPercent = Math.abs(((row.actualSales - row.plannedSales)/row.actualSales*100).toFixed(1)); 
                    row.plannedDiffRMSE = Math.round(Math.sqrt( (row.actualSales - row.plannedSales) * (row.actualSales - row.plannedSales)));

                    dayStats[dateKeyDaily].sumManagerWeights += row.plannedDiff*100;
                    dayStats[dateKeyDaily].sumManagerSales += row.actualSales;
                    
                    
                    let difference = row.plannedSales - row.actualSales;
                    this.rmsdSquareSums['manager'] += (difference*difference);
                    this.rmsdLengths['manager']++;
                }
                if(row.forecast != null && row.actualSales != null){
                    row.forecastDiff = Math.abs(row.actualSales - row.forecast);
                    row.forecastDiffPercent = Math.abs(((row.actualSales - row.forecast)/row.actualSales*100).toFixed(1));
                    row.forecastDiffRMSE = Math.round(Math.sqrt( (row.actualSales - row.forecast) * (row.actualSales - row.forecast)));

                    dayStats[dateKeyDaily].sumForecastWeights += row.forecastDiff * 100;
                    dayStats[dateKeyDaily].sumForecastSales += row.actualSales;

                    let difference = row.forecast - row.actualSales;
                    this.rmsdSquareSums['forecast'] += (difference*difference);
                    this.rmsdLengths['forecast']++;
                }
                
                if(row.dataInsightSales != null && row.actualNetSales != null){
                    row.dataInsightSalesDiff = Math.abs(row.actualNetSales - row.dataInsightSales);
                    row.dataInsightSalesDiffPercent = Math.abs(((row.actualNetSales - row.dataInsightSales)/row.actualNetSales*100).toFixed(1));
                    row.dataInsightSalesDiffRMSE = Math.round(Math.sqrt( (row.actualNetSales - row.dataInsightSales) * (row.actualNetSales - row.dataInsightSales)));
                    
                    dayStats[dateKeyDaily].sumDataInsightWeights += row.dataInsightSalesDiff * 100;
                    dayStats[dateKeyDaily].sumDataInsightSales += row.actualNetSales;
                    
                    let difference = row.dataInsightSales - row.actualNetSales;
                    this.rmsdSquareSums['datainsight'] += (difference*difference);
                    this.rmsdLengths['datainsight']++;
                }


                if(row.actualSales != null && row.actualNetSales != null && (row.plannedSales != null  || row.forecast != null || row.dataInsightSales != null) ){
                   

                    if(row.plannedSales != null) this.deviationsAbsEuro['manager'] += row.plannedDiff;
                    if(row.forecast != null) this.deviationsAbsEuro['forecast'] += row.forecastDiff;
                    
                    if(row.dataInsightSales != null) this.deviationsAbsEuro['datainsight'] += row.dataInsightSalesDiff;
                    this.comparisons++;

                    
                    
                    let smallest = 9999999999;
                    if(row.forecast != null) smallest = Math.min(smallest, row.plannedDiff, row.forecastDiff);
                    if(smallest === row.forecastDiff) {
                        this.sumBest['forecast']++;
                    }
                   
                    smallest = 9999999999;
                    if(row.dataInsightSales != null) smallest = Math.min(smallest, row.plannedDiff, row.dataInsightSalesDiff);
                    if(smallest === row.dataInsightSalesDiff) {
                        this.sumBest['datainsight']++;
                    } 

                    smallest = 9999999999;
                    if(row.forecast != null) smallest = Math.min(smallest, row.plannedDiffRMSE, row.forecastDiffRMSE);
                    
                    if(row.dataInsightSales != null) smallest = Math.min(smallest, row.plannedDiffRMSE, row.dataInsightSalesDiffRMSE);

                    if(smallest === row.plannedDiffRMSE) {
                        row.winner = 'manager';
                    } else if(smallest === row.forecastDiffRMSE) {
                        row.winner = 'forecast';
                    } else if(smallest === row.dataInsightSalesDiffRMSE) {
                        row.winner = 'datainsight';
                    }

                }
                myTable.push(row);
                start = start.add(1,'hours');
            }

            //calculate wmape and accuracy
            let totalManagerWeights = 0;
            let totalForecastWeights = 0;
            let totalDataInsightWeights = 0;
            let totalManagerSales = 0;
            let totalForecastSales = 0;
            let totalDataInsightSales = 0;
            console.log(dayStats);
            myTable.filter(r => !r.hourly).forEach(row => {
                let dateKeyDaily = row.mapsKey;
                let dayStat = dayStats[dateKeyDaily];

                totalManagerWeights += dayStat.sumManagerWeights;
                totalForecastWeights += dayStat.sumForecastWeights;
                totalDataInsightWeights += dayStat.sumDataInsightWeights;
                totalManagerSales += dayStat.sumManagerSales;
                totalForecastSales += dayStat.sumForecastSales;
                totalDataInsightSales += dayStat.sumDataInsightSales;

                if(dayStat.sumManagerSales > 0){
                    row.wmapeManager = dayStat.sumManagerWeights / dayStat.sumManagerSales;
                    row.accuracyManager = (100 - row.wmapeManager).toFixed(2);
                    
                } else {
                    row.wmapeManager = 0;
                    row.accuracyManager = 0;
                }
                if(dayStat.sumForecastSales > 0){
                    row.wmapeForecast = dayStat.sumForecastWeights / dayStat.sumForecastSales;
                    row.accuracyForecast = (100 - row.wmapeForecast).toFixed(2);
                } else {
                    row.wmapeForecast = 0;
                    row.accuracyForecast = 0;
                }
                if(dayStat.sumDataInsightSales > 0){
                    row.wmapeDataInsight = dayStat.sumDataInsightWeights / dayStat.sumDataInsightSales;
                    row.accuracyDataInsight = (100 - row.wmapeDataInsight).toFixed(2);
                } else {
                    row.wmapeDataInsight = 0;
                    row.accuracyDataInsight = 0;
                }

                let highestDailyAccuracy = Math.max(0, parseFloat(row.accuracyManager), parseFloat(row.accuracyForecast), parseFloat(row.accuracyDataInsight)).toFixed(2);
                console.log(dateKeyDaily + " / " + row.accuracyManager + " / " + row.accuracyForecast + " / " + row.accuracyDataInsight + " / " + highestDailyAccuracy);
                if(!row.isPast || parseFloat(row.accuracyManager) == 0 && parseFloat(row.accuracyForecast) == 0 && parseFloat(row.accuracyDataInsight) == 0){
                    row.winner = 'na';
                } else{
                    if(highestDailyAccuracy == row.accuracyManager) {
                        row.winner = 'manager';
                    } else if(highestDailyAccuracy == row.accuracyForecast) {
                        row.winner = 'forecast';
                    } else if(highestDailyAccuracy == row.accuracyDataInsight) {
                        row.winner = 'datainsight';
                    } 
                }
     
            });
            if(totalManagerSales > 0){
                this.wmape['manager'] = totalManagerWeights / totalManagerSales;
                this.accuracy['manager'] = (100 - this.wmape['manager']).toFixed(2);
            }
            if(totalForecastSales > 0){
                this.wmape['forecast'] = totalForecastWeights / totalForecastSales;
                this.accuracy['forecast'] = (100 - this.wmape['forecast']).toFixed(2);
            }
            if(totalDataInsightSales > 0){
                this.wmape['datainsight'] = totalDataInsightWeights / totalDataInsightSales;
                this.accuracy['datainsight'] = (100 - this.wmape['datainsight']).toFixed(2);
            }
            let highestTotalAccuracy = Math.max(0, parseFloat(this.accuracy.manager), parseFloat(this.accuracy.forecast), parseFloat(this.accuracy.datainsight)).toFixed(2);
            if(highestTotalAccuracy == this.accuracy.manager) {
                this.accuracy.winner = 'manager';
            } else if(highestTotalAccuracy == this.accuracy.forecast) {
                this.accuracy.winner = 'forecast';
            } else if(highestTotalAccuracy == this.accuracy.datainsight) {
                this.accuracy.winner = 'datainsight';
            } 

            

            this.sumTotalDev['manager'] = Math.round(this.sumPLAN['manager'] - this.sumIST);
            this.sumTotalDev['forecast'] = Math.round(this.sumPLAN['forecast'] - this.sumIST);
            this.sumTotalDev['datainsight'] = Math.round(this.sumPLAN['datainsight'] - this.sumNetIST);


            
          
            
           
           

            let winner = 9999999999;
            if(this.deviationsAbsEuro['manager'] > 0 ){
                winner = Math.min(this.deviationsAbsEuro['manager'], winner);
            }
            if(this.deviationsAbsEuro['forecast'] > 0 ){
                winner = Math.min(this.deviationsAbsEuro['forecast'], winner);
            }
           
            if(this.deviationsAbsEuro['datainsight'] > 0 ){
                winner = Math.min(this.deviationsAbsEuro['datainsight'], winner);
            }

            
            if(winner == this.deviationsAbsEuro['manager']) {
                this.deviationsAbsEuro['winner'] = 'manager';
            } else if(winner == this.deviationsAbsEuro['forecast']) {
                this.deviationsAbsEuro['winner'] = 'forecast';
            } else if(winner == this.deviationsAbsEuro['datainsight']) {
                this.deviationsAbsEuro['winner'] = 'datainsight';
            }


            
          

            this.sumBest['winner'] = Math.max(this.sumBest['forecast'], this.sumBest['datainsight']);
            
            winner = 9999999999;
            winner = Math.min(Math.abs(this.sumTotalDev['manager']), winner);
            winner = Math.min(Math.abs(this.sumTotalDev['forecast']), winner);
            winner = Math.min(Math.abs(this.sumTotalDev['datainsight']), winner);
            

            
            if(winner == Math.abs(this.sumTotalDev['manager'])) {
                this.sumTotalDev['winner'] = 'manager';
            } else if(winner == Math.abs(this.sumTotalDev['forecast'])) {
                this.sumTotalDev['winner'] = 'forecast';
            } else if(winner == Math.abs(this.sumTotalDev['datainsight'])) {
                this.sumTotalDev['winner'] = 'datainsight';
            }

            this.rmsds['manager'] = Math.round(Math.sqrt(this.rmsdSquareSums['manager'] / this.rmsdLengths['manager']));
            this.rmsds['forecast'] = Math.round(Math.sqrt(this.rmsdSquareSums['forecast'] / this.rmsdLengths['forecast']));
           
            this.rmsds['datainsight'] = Math.round(Math.sqrt(this.rmsdSquareSums['datainsight'] / this.rmsdLengths['datainsight']));

            winner = 9999999999;
            if(this.rmsds['manager'] > 0 ){
                winner = Math.min(this.rmsds['manager'], winner);
            }
            if(this.rmsds['forecast'] > 0 ){
                winner = Math.min(this.rmsds['forecast'], winner);
            }
          
            if(this.rmsds['datainsight'] > 0 ){
                winner = Math.min(this.rmsds['datainsight'], winner);
            }

            
            if(winner == this.rmsds['manager']) {
                this.rmsds['winner'] = 'manager';
            } else if(winner == this.rmsds['forecast']) {
                this.rmsds['winner'] = 'forecast';
            } else if(winner == this.rmsds['datainsight']) {
                this.rmsds['winner'] = 'datainsight';
            }

            this.dailyTable = myTable;
            console.log(this.dailyTable);
        },
        

        

        loadForecastData: function(){
            let view = this;
            view.forecastLoading = true;
            view.forecastLoaded = true;
            view.forecastLoadingError = false;
            let start = this.dateSelectionStart.clone().startOf('month');
            let from = this.dateSelectionStart.clone().startOf('month').format();
            let to = start.clone().add(1,'months').format();

            this.axios({
                method: 'get',
                params: { storeId: this.$store.state.storeId },
                headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                url: '/api/sec/salesforecast'
            }).then(response => {
                view.forecastData = response.data;
                this.axios({
                    method: 'get',
                    params: { storeId: this.$store.state.storeId, from: from, to: to },
                    headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                    url: '/api/sec/salesforecast/historic'
                }).then(response => {
                    view.forecastLoading = false;
                    view.forecastLoaded = true;
                    view.forecastLoadingError = false;
                    view.forecastDataHistoric = response.data;
                    view.createForecastMap();
                    view.calculateDailyMap();
                }).catch(error => {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der historeischen MD Prognose Daten');
                    view.forecastLoading = false;
                    view.forecastLoaded = false;
                    view.forecastLoadingError = true;
                });
            }).catch(error => {
                view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der MD Prognose Daten');
                view.forecastLoading = false;
                view.forecastLoaded = false;
                view.forecastLoadingError = true;
            });
        },
        loadDataInsightForecastData: function(){
            let view = this;
           

            let from = this.dateSelectionStart.clone().startOf('month');
            let to = from.clone().add(1,'months');
            
            this.axios({
                method: 'get',
                params: { storeId: this.$store.state.storeId, from: from.format(), to: to.format() },
                headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                url: '/api/sec/statistics/datainsight/forecast'
            }).then(response => {
                view.$helpers.success(view.$t('global.notifications.success'), 'DataInsight Prognose Daten erfolgreich geladen');
                view.OpenDataInsightForecastResultPopup(response.data)
            }).catch(error => {
                view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der DataInsight Prognose Daten');
                
            });
        },
        OpenDataInsightForecastResultPopup(data){
           
            let view = this;
            let dataInsightItems = [];
            data.sort((a,b) => view.$helpers.getMomentFromStringTZ(a.creationDate) - view.$helpers.getMomentFromStringTZ(b.creationDate).unix()).forEach(item => {
                if((item.resolution == '60min') && (item.status == 'finished' || item.status == 'processing')){
                    let creationDate = view.$helpers.getMomentFromStringTZ(item.creationDate).format('DD.MM.YYYY HH:mm');
                    let from = view.$helpers.getMomentFromStringTZ(item.from).format('DD.MM.YYYY HH:mm');
                    let to = view.$helpers.getMomentFromStringTZ(item.to).format('DD.MM.YYYY HH:mm');
                    dataInsightItems.push({label: 'Planung: '+creationDate+" - " + this.$t('global.general.from') + ": "+from+" " + this.$t('global.general.to') + ": "+to, key: item.id, value: {id: item.id, creationDate: item.creationDate}});
                }
            })
            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                entries: [
                    {
                    label: "Prognose",
                    key: 'ids',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    flexGroup: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: dataInsightItems,
                        selectMultiple: true,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar) {
                        },
                        styleLight: true,
                        placeholder: 'Prognose auswählen',
                    },
                    styles: {width: '600px'}
                    },
                    
                ],
                errorCheck: [
                    (entries) => {
                        if (!entries["ids"]) {
                            return {
                            key: 'ids',
                            type: 'error',
                            label: "Prognose",
                            text: 'Bitte wählen Sie eine Prognose aus!'
                            }
                        } else {
                            return null
                        }
                    },
                    
                    
                ],
                selectCallback: function (item) {
                    view.loadDataInsightForecastResult(item.ids, {});
                }
                },
                header: 'DataInsight Ergebnisse',
                centered: true,
                expanded: true,
            });
    
        },
        loadDataInsightForecastResult: function(entries, resultMap){
            let view = this;
            if(entries.length == 0){
                let result = Object.values(resultMap).map(e => e.value);
                view.$helpers.success(view.$t('global.notifications.success'), 'DataInsight Prognose Ergebnis wurde erfolgreich geladen');
                view.createDataInsightMap(result);
                view.calculateDailyMap();
            } else {
                let entry = entries.pop();
                    this.axios({
                    method: 'get',
                    params: { storeId: this.$store.state.storeId, id: entry.id },
                    headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                    url: '/api/sec/statistics/datainsight/forecast'
                }).then(response => {
                    if(response.data.status == 'finished' && response.data.data != null){
                        response.data.data.forEach(item => {
                            if(!resultMap[item.timestamp]){
                                resultMap[item.timestamp] = {value: item, creationDate: view.$helpers.getMomentFromStringTZ(entry.creationDate)};
                            } else {
                                let cdOld = resultMap[item.timestamp].creationDate;
                                let cdNew = view.$helpers.getMomentFromStringTZ(entry.creationDate);
                                if(cdNew.isAfter(cdOld)){
                                    resultMap[item.timestamp] = {value: item, creationDate: view.$helpers.getMomentFromStringTZ(entry.creationDate)};
                                }
                            }
                            
                        });
                       
                    } else if(response.data.status == 'processing'){
                        view.$helpers.error(view.$t('global.notifications.error'), 'Diese Prognose ist noch in Arbeit');
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), 'Diese Prognose hat einen Fehler');
                    }
                    view.loadDataInsightForecastResult(entries, resultMap);
                    
                }).catch(error => {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der DataInsight Prognose Daten');
                    view.loadDataInsightForecastResult(entries, resultMap);
                });
            }

            
        },
        
        createDataInsightMap(data) {
            this.dataInsightMapDaily = {};
            this.dataInsightMapDailySquared = {};
            this.dataInsightMapDailyLength = {};
            this.dataInsightMap = {};
            
            let start = this.dateSelectionStart.clone().startOf('month');
            const newDate = moment("2023-09-13 00:00:00+02:00");
            const modifiedStart = start.isAfter(newDate) ? start : newDate;
            let end = end = start.clone().endOf('month').add(1,'days').startOf('day');
            data.forEach(item => {
                if(item.yhat >= 0){
                    const dateInVienna = moment.tz(item.timestamp, "Europe/Vienna");
                    if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                        const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                        if (!this.dataInsightMapDaily[formattedDateDaily]) {
                            this.dataInsightMapDaily[formattedDateDaily] = item.yhat;
                        } else {
                            this.dataInsightMapDaily[formattedDateDaily] += item.yhat;
                        }
                        const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                        if (!this.dataInsightMap[formattedDate]) {
                            this.dataInsightMap[formattedDate] = item.yhat;
                        } else {
                            this.dataInsightMap[formattedDate] += item.yhat;
                        }

                        if(this.netSalesMapActual[formattedDate] && this.netSalesMapActual[formattedDate] > 0){
                            let difference = item.yhat - this.netSalesMapActual[formattedDate];
                            if (!this.dataInsightMapDailySquared[formattedDateDaily]) {
                                this.dataInsightMapDailySquared[formattedDateDaily] = (difference*difference);
                                this.dataInsightMapDailyLength[formattedDateDaily] = 1;
                            } else {
                                this.dataInsightMapDailySquared[formattedDateDaily] += (difference*difference);
                                this.dataInsightMapDailyLength[formattedDateDaily]++;
                            }
                        }
                    }
                }
            });
            
        },
        

        loadPlanningIndicatorsPagedCompletely : function(from, to, indicator) {
            return this.axios({
                method: 'get',
                params: { storeId: this.$store.state.storeId, from: from, to: to, typeId: indicator },
                headers: { 'AUTHORIZATION': "bearer "+this.$store.state.jwt },
                url: '/api/sec/planningindicator/grouped/hour'
            }).then(response => {
                return response.data;
            })
        },
        updatePlanningIndicatorTypes: function(data) {
            let map = {};
            for (let i = 0; i < data.length; i++) {
                if(data[i].category == 1){
                    this.salesIndicatorId = data[i].id;
                    map[data[i].id] = data[i];
                }
                if(data[i].category == 2){
                    this.netSalesIndicatorId = data[i].id;
                    map[data[i].id] = data[i];
                }
                
            }
            this.planningIndicatorTypeMap = map;
        },
        
        createExpandedMap() {
            this.expandedMap = {};
            
            let start = this.dateSelectionStart.clone().startOf('month');
            let end = start.clone().add(1,'months');
            while(end.diff(start) > 0){
                let dayTime = start.clone();
                let dateKeyDaily = dayTime.format("YYYY-MM-DD");
                let dateKey = dayTime.format("YYYY-MM-DD HH");
                if(dayTime.format("HH") == "00"){
                    this.expandedMap[dateKeyDaily] = true;
                }
                this.expandedMap[dateKey] = false;
                start = start.add(1,'hours');
            }
        },

        createForecastMap() {
            this.forecastMapDaily = {};
            this.forecastMapDailySquared = {};
            this.forecastMapDailyLength = {};
            this.forecastMap = {};
            
            let start = this.dateSelectionStart.clone().startOf('month');
            const newDate = moment("2023-09-13 00:00:00+02:00");
            const modifiedStart = start.isAfter(newDate) ? start : newDate;
            let end = start.clone().endOf('month');
            this.forecastData.forEach(item => {
                if(item.forecast >= 0){
                    const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                    if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                        const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                        if (!this.forecastMapDaily[formattedDateDaily]) {
                            this.forecastMapDaily[formattedDateDaily] = item.forecast;
                        } else {
                            this.forecastMapDaily[formattedDateDaily] += item.forecast;
                        }
                        const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                        if (!this.forecastMap[formattedDate]) {
                            this.forecastMap[formattedDate] = item.forecast;
                        } else {
                            this.forecastMap[formattedDate] += item.forecast;
                        }
                    }
                }
            });
            this.forecastDataHistoric.forEach(item => {
                if(item.forecast > 0){
                    const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                    if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                        const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                        if (!this.forecastMap[formattedDate]) {
                            this.forecastMap[formattedDate] = item.forecast;
                        } else {
                            this.forecastMap[formattedDate] += item.forecast;
                        }
                        const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                        if (!this.forecastMapDaily[formattedDateDaily]) {
                            this.forecastMapDaily[formattedDateDaily] = item.forecast;
                        } else {
                            this.forecastMapDaily[formattedDateDaily] += item.forecast;
                        }

                        if(this.salesMapActual[formattedDate] && this.salesMapActual[formattedDate] > 0){
                            let difference = item.forecast - this.salesMapActual[formattedDate];
                            if (!this.forecastMapDailySquared[formattedDateDaily]) {
                                this.forecastMapDailySquared[formattedDateDaily] = (difference*difference);
                                this.forecastMapDailyLength[formattedDateDaily] = 1;
                            } else {
                                this.forecastMapDailySquared[formattedDateDaily] += (difference*difference);
                                this.forecastMapDailyLength[formattedDateDaily]++;
                            }
                        }
                    }
                }
            });
            console.log(this.forecastMapDaily);
        },


        createSalesMap() {
            // store 66 , tag: 7.10.2023 11:00 , SOLL 213 , 217 , 228 , 303
            // store 66 , tag: 7.10.2023 11:00 , IST 264.84 , 321.69 , 328.61 , 282.63
            this.salesMapPlannedDaily = {};
            this.salesMapActualDaily = {};
            
            this.salesMapPlanned = {};
            this.salesMapActual = {};
            
            this.managerMapDailySquared = {};
            this.managerMapDailyLength = {};
            let start = this.dateSelectionStart.clone().startOf('month');
            const newDate = moment("2023-09-13 00:00:00+02:00");
            const modifiedStart = start.isAfter(newDate) ? start : newDate;
            let end = start.clone().endOf('month');

            this.salesData.filter(item => !item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    if(item.typeId == this.salesIndicatorId){
                        if (!this.salesMapActualDaily[formattedDateDaily]) {
                            this.salesMapActualDaily[formattedDateDaily] = amount;
                        } else {
                            this.salesMapActualDaily[formattedDateDaily] += amount;
                        }
                        if (!this.salesMapActual[formattedDate]) {
                            this.salesMapActual[formattedDate] = amount;
                        } else {
                            this.salesMapActual[formattedDate] += amount;
                        }
                    }
                    
                }
            });
            this.salesData.filter(item => item.planned && item.typeId == this.salesIndicatorId).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");

                    if (!this.salesMapPlannedDaily[formattedDateDaily]) {
                        this.salesMapPlannedDaily[formattedDateDaily] = amount;
                    } else {
                        this.salesMapPlannedDaily[formattedDateDaily] += amount;
                    }

                    if (!this.salesMapPlanned[formattedDate]) {
                        this.salesMapPlanned[formattedDate] = amount;
                    } else {
                        this.salesMapPlanned[formattedDate] += amount;
                    }

                    if(this.salesMapActual[formattedDate] && this.salesMapActual[formattedDate] > 0){
                        let difference = amount - this.salesMapActual[formattedDate];
                        if (!this.managerMapDailySquared[formattedDateDaily]) {
                            this.managerMapDailySquared[formattedDateDaily] = (difference*difference);
                            this.managerMapDailyLength[formattedDateDaily] = 1;
                        } else {
                            this.managerMapDailySquared[formattedDateDaily] += (difference*difference);
                            this.managerMapDailyLength[formattedDateDaily]++;
                        }
                    }
                    
                }
            });
            
        },
        createNetSalesMap() {
           
            this.netSalesMapActualDaily = {};
            this.netSalesMapActual = {};

            let start = this.dateSelectionStart.clone().startOf('month');
            const newDate = moment("2023-09-13 00:00:00+02:00");
            const modifiedStart = start.isAfter(newDate) ? start : newDate;
            let end = start.clone().endOf('month').add(1,'days').startOf('day');

            this.netSalesData.filter(item => !item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(modifiedStart, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    const formattedDateDaily = dateInVienna.format("YYYY-MM-DD");
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    
                    if(item.typeId == this.netSalesIndicatorId){
                        if (!this.netSalesMapActualDaily[formattedDateDaily]) {
                            this.netSalesMapActualDaily[formattedDateDaily] = amount;
                        } else {
                            this.netSalesMapActualDaily[formattedDateDaily] += amount;
                        }
                        if (!this.netSalesMapActual[formattedDate]) {
                            this.netSalesMapActual[formattedDate] = amount;
                        } else {
                            this.netSalesMapActual[formattedDate] += amount;
                        }
                    } 
                }
            });
            
        },
        exportDataInsightToCSV(){
            

            let start = this.dateSelectionStart.clone().startOf('month');
            
            let end = start.clone().endOf('month').add(1,'days').startOf('day');
            let netSalesMap = {};
            this.netSalesData.filter(item => !item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(start, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    
                    if(item.typeId == this.netSalesIndicatorId){
                        
                        if (!netSalesMap[formattedDate]) {
                            netSalesMap[formattedDate] = amount;
                        } else {
                            netSalesMap[formattedDate] += amount;
                        }
                    } 
                }
            });

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');
            let dataInsightMap = {};
            this.dataInsightData.forEach(item => {
                const dateInVienna = moment.tz(item.timestamp, "Europe/Vienna");
                if (dateInVienna.isBetween(start, end, null, '[]')) {
                    const amount = item.yhat;
                    
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    if (!dataInsightMap[formattedDate]) {
                        dataInsightMap[formattedDate] = amount;
                    } else {
                        dataInsightMap[formattedDate] += amount;
                    }
                }
            });

            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('store.settings.date'), 'Umsatz (Netto)', 'DataInsight Prognose', 'Abs. Error'];
             let filename = 'Forecast_DataInsight_' + this.storeSettings.id + '_' + this.dateSelectionStart.format("MM_YYYY") +  '.csv';
                
            csv += headers.join(";");
            csv += "\n";

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');

            while(start < end){
                const dateInVienna = moment.tz(start, "Europe/Vienna");
                const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                let netSales = netSalesMap[formattedDate];
                let dataInsight = dataInsightMap[formattedDate];
                let error = 0;
                if(netSales != null && dataInsight != null){
                    error = Math.abs(netSales - dataInsight);
                }
                if(netSales == null){
                    netSales = 0;
                }
                if(dataInsight == null){
                    dataInsight = 0;
                }
                let cur = [dateInVienna.format(), (""+netSales.toFixed(2)).replace('.',','), (""+dataInsight.toFixed(2)).replace('.',','), (""+error.toFixed(2)).replace('.',',')];
                csv += cur.join(";");
                csv += "\n";

                start = start.add(1,'hours');
            }
            
            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
 
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();


        },
        exportMDForecastToCSV(){
            

            let start = this.dateSelectionStart.clone().startOf('month');
            
            let end = start.clone().endOf('month').add(1,'days').startOf('day');
            let salesMap = {};
            this.salesData.filter(item => !item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(start, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    
                    if(item.typeId == this.salesIndicatorId){
                        
                        if (!salesMap[formattedDate]) {
                            salesMap[formattedDate] = amount;
                        } else {
                            salesMap[formattedDate] += amount;
                        }
                    } 
                }
            });

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');
            let forecastMap = {};
            

            this.forecastData.forEach(item => {
                if(item.forecast >= 0){
                    const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                    if (dateInVienna.isBetween(start, end, null, '[]')) {
                        
                        const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                        if (!forecastMap[formattedDate]) {
                            forecastMap[formattedDate] = item.forecast;
                        } else {
                            forecastMap[formattedDate] += item.forecast;
                        }
                    }
                }
            });
            this.forecastDataHistoric.forEach(item => {
                if(item.forecast > 0){
                    const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                    if (dateInVienna.isBetween(start, end, null, '[]')) {
                        const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                        if (!forecastMap[formattedDate]) {
                            forecastMap[formattedDate] = item.forecast;
                        } else {
                            forecastMap[formattedDate] += item.forecast;
                        }
                        

                       
                    }
                }
            });

            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('store.settings.date'), 'Umsatz (Brutto)', 'MD Prognose', 'Abs. Error'];
             let filename = 'Forecast_MD_' + this.storeSettings.id + '_' + this.dateSelectionStart.format("MM_YYYY") +  '.csv';
                
            csv += headers.join(";");
            csv += "\n";

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');

            while(start < end){
                const dateInVienna = moment.tz(start, "Europe/Vienna");
                const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                let sales = salesMap[formattedDate];
                let forecast = forecastMap[formattedDate];
                let error = 0;
                if(sales != null && forecast != null){
                    error = Math.abs(sales - forecast);
                }
                if(sales == null){
                    sales = 0;
                }
                if(forecast == null){
                    forecast = 0;
                }
                let cur = [dateInVienna.format("DD.MM.YYYY HH:mm"), (""+sales.toFixed(2)).replace('.',','), (""+forecast.toFixed(2)).replace('.',','), (""+error.toFixed(2)).replace('.',',')];
                csv += cur.join(";");
                csv += "\n";

                start = start.add(1,'hours');
            }
            
            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
 
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();


        },
        exportManagerToCSV(){
            

            let start = this.dateSelectionStart.clone().startOf('month');
            
            let end = start.clone().endOf('month').add(1,'days').startOf('day');
            let salesMap = {};
            this.salesData.filter(item => !item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(start, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    
                    if(item.typeId == this.salesIndicatorId){
                        
                        if (!salesMap[formattedDate]) {
                            salesMap[formattedDate] = amount;
                        } else {
                            salesMap[formattedDate] += amount;
                        }
                    } 
                }
            });

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');
            let mgmtMap = {};
            this.salesData.filter(item => item.planned).forEach(item => {
                const dateInVienna = moment.tz(item.date, "Europe/Vienna");
                if (dateInVienna.isBetween(start, end, null, '[]')) {
                    const amount = item.sumAmount/10000000.0;
                    
                    const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                    if(item.typeId == this.salesIndicatorId){
                        
                        if (!mgmtMap[formattedDate]) {
                            mgmtMap[formattedDate] = amount;
                        } else {
                            mgmtMap[formattedDate] += amount;
                        }
                    } 
                }
            });

            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('store.settings.date'), 'Umsatz (Brutto)', 'Management Prognose', 'Abs. Error'];
             let filename = 'Forecast_Management_' + this.storeSettings.id + '_' + this.dateSelectionStart.format("MM_YYYY") +  '.csv';
                
            csv += headers.join(";");
            csv += "\n";

            start = this.dateSelectionStart.clone().startOf('month');
            end = start.clone().endOf('month').add(1,'days').startOf('day');

            while(start < end){
                const dateInVienna = moment.tz(start, "Europe/Vienna");
                const formattedDate = dateInVienna.format("YYYY-MM-DD HH");
                let sales = salesMap[formattedDate];
                let mgmt = mgmtMap[formattedDate];
                let error = 0;
                if(sales != null && mgmt != null){
                    error = Math.abs(sales - mgmt);
                }
                if(sales == null){
                    sales = 0;
                }
                if(mgmt == null){
                    mgmt = 0;
                }
                let cur = [dateInVienna.format("DD.MM.YYYY HH:mm"), (""+sales.toFixed(2)).replace('.',','), (""+mgmt.toFixed(2)).replace('.',','), (""+error.toFixed(2)).replace('.',',')];
                csv += cur.join(";");
                csv += "\n";

                start = start.add(1,'hours');
            }
            
            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
 
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();


        },
        OpenDateSelection($event){
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: this.indicatorDateView ? ['D'] : ['M'], date: this.indicatorDateView ? this.indicatorDateView.clone() : this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.setDateSelection(date, true) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .loading{

        -webkit-filter: none !important;
        filter: none !important;
        position: absolute;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        bottom: 0;
        left: 0;
        top: initial;
        width: 100%;
        height: calc(100vh - 109px);
        background: rgba(0,0,0,.5);
        z-index: 10;
        position: fixed;
    }

    .header > .header.date{
        width: fit-content;
    }

    .paging{
        top: 0;
        bottom: 0;
        right: 250px;
    }

    .header > .text-filter{
        top: 0;
        bottom: 0;
        width: 230px;
        right: 45px;
    }
    .border-left {
        /* border-left: 3px solid #000 !important; */
    }
    .border-right {
        /* border-right: 3px solid #000 !important; */
    }

    .data-section {
        width: 45%;
        float:left;
    }
    
    
    .deviation {
        background-color: #edf2f7;
        border-radius: 10px;
        padding: 20px;
        margin-top: 20px;
        position: relative;
    }
    .info {
        font-weight: bold;
        color: #6d8d23;
      background-color: #6d8d2320!important;
    }

    .info-nobg {
        font-weight: bold;
        color: #6d8d23;
    }
    .infoHourly {
        font-weight: bold;
        color: #6d8d23;
      background-color: #6d8d2320 !important;
    }
    .nowinner {
        background-color: var(--contrast-0);
        color: var(--contrast-7);
    }
    .nowinnerHourly {
        background-color: var(--contrast-0);
        color: var(--contrast-7);
    }
    .minimal-padding {
      padding: 2px !important;
    }
    .mouse-pointer {
        cursor: pointer !important;
    }

</style>
